import { render, staticRenderFns } from "./header-user.vue?vue&type=template&id=476d4bac&scoped=true&"
import script from "./header-user.vue?vue&type=script&lang=js&"
export * from "./header-user.vue?vue&type=script&lang=js&"
import style0 from "./header-user.vue?vue&type=style&index=0&id=476d4bac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d4bac",
  null
  
)

export default component.exports